import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

import { ToastNotificationListComponent } from './toast-notification-list.component';
import { ToastNotificationModule } from '../toast-notification';

/**
 * A module containing objects associated with toast notification lists
 */

export class ToastNotificationListModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    FormsModule,
    ToastNotificationModule
  ],
  declarations: [
    ToastNotificationListComponent
  ],
  exports: [
    ToastNotificationListComponent
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
